var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",on:{"click":function($event){return _vm.$emit('click')}}},[_c('use',{attrs:{"xlink:href":'#'+_vm.name}})])}
var staticRenderFns = []

export { render, staticRenderFns }